import React from "react"
import { ShieldCheck, Eye, Calendar } from "lucide-react"
import ReelPlayer from "./ReelPlayer"
import Avatar from "./Avatar"
import CaptionText from "./CaptionText"
import { formatViews } from "../utils"

/**
 * Instagram-only grid tile. Unlike VideoCard (YouTube), this does NOT go
 * through a static thumbnail at all - the preview surface is ReelPlayer, a
 * real <video src={video.url}> element, embedded directly in the grid card,
 * not just in the detail view. That's deliberate: a static `thumbnail_url`
 * has repeatedly not been a reliable preview for these reels, while the
 * reel's own `url` played directly through <video> has been confirmed to
 * work, so the grid should show that real preview up front rather than
 * hiding it behind a click-through.
 */
const ReelCard = ({ video, onOpen }) => (
    <div style={{
        background: "#1c1d27",
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: "16px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        height: "100%",
    }}>
        <div style={{ position: "relative", width: "100%", aspectRatio: "9 / 16", background: "#000" }}>
            <ReelPlayer video={video} onOpen={() => onOpen(video)} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />

            <div style={{ position: "absolute", top: "8px", left: "8px", display: "flex", gap: "6px", pointerEvents: "none" }}>
                <span style={{ display: "flex", alignItems: "center", gap: "4px", background: "#E1306C", color: "#fff", fontSize: "10px", fontWeight: 700, padding: "2px 7px", borderRadius: "5px" }}>
                    REEL
                </span>
                {video.verification?.verified && (
                    <span style={{ display: "flex", alignItems: "center", gap: "4px", background: "rgba(16,185,129,0.9)", color: "#fff", fontSize: "10px", fontWeight: 700, padding: "2px 7px", borderRadius: "5px" }}>
                        <ShieldCheck size={11} /> Verified
                    </span>
                )}
            </div>
        </div>

        {/* The video above is the preview; this footer is the click target
            for the full detail view (summary, verification reasoning, etc.) -
            it never sits on top of the <video controls> area. */}
        <div onClick={() => onOpen(video)} style={{ padding: "12px 14px 14px", cursor: "pointer", display: "flex", flexDirection: "column", gap: "6px", flex: 1 }}>
            <h5
                className="ugc-clamp-2"
                style={{ color: "#fff", fontSize: "13.5px", fontWeight: 600, margin: 0, lineHeight: "1.4", fontFamily: "Rubik" }}
                title={video.title}
            >
                <CaptionText text={video.title} />
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "11.5px", color: "#9ca3af", flexWrap: "wrap" }}>
                <Avatar src={video.profile_pic_url} alt={video.channel_name} size={16} />
                <span style={{ fontWeight: 500 }}>{video.channel_name}</span>
                <span>•</span>
                <span style={{ display: "flex", alignItems: "center", gap: "4px" }}><Eye size={11} /> {formatViews(video.metrics?.views)}</span>
                <span>•</span>
                <span style={{ display: "flex", alignItems: "center", gap: "4px" }}><Calendar size={11} /> {video.published_time_text}</span>
            </div>
        </div>
    </div>
)

export default ReelCard
